// Mobile menu toggle
const toggle = document.querySelector(".menu-toggle");
const nav = document.querySelector(".nav");
if (toggle && nav) {
  toggle.addEventListener("click", () => {
    nav.classList.toggle("is-open");
    const open = nav.classList.contains("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
}

// Header subtle shadow on scroll
const header = document.querySelector(".site-header");
if (header) {
  const onScroll = () => {
    if (window.scrollY > 8) header.classList.add("is-scrolled");
    else header.classList.remove("is-scrolled");
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}
